// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qf0q","footer":"styles_footer__tYhMv","passCodeTooltip":"styles_passCodeTooltip__1gUMJ"};